import { ref } from 'vue';
import { defineStore } from 'pinia';

import ApiModuleStatuses from '@/api/ApiModuleStatuses';
import { getNowDayJs, getDayJsDiffMinutes, datetimeToString } from '@/components/common/dateUtils';

import { useUserStore } from '@/stores/user';
import TranslationUtils from '@/i18n/TranslationUtils';

import type { ModuleStatusKey, ModuleStatusRaw, ModuleStatusesResponse } from '@/api/ApiTypes';


const OLD_STATUS_MINUTES = 5;

export const useModuleStatusesStore = defineStore('moduleStatuses', () => {
	const statuses = ref<ModuleStatusRaw[]>([]);
	const summary = ref<ModuleStatusKey>('unknown');

	const update = (newStatuses: ModuleStatusRaw[], newSummary: ModuleStatusKey): void => {
		statuses.value = newStatuses;
		summary.value = newSummary;
	};

	const handle = (responseData: ModuleStatusesResponse): void => {
		if (!Array.isArray(responseData.module_statuses) || responseData.summary == null) {
			console.warn('invalid module statuses response', {
				status: responseData.status,
				responseKeys: Object.keys(responseData),
			});
			handleError();
			return;
		}
		const now = getNowDayJs();
		let { module_statuses, summary: newSummary } = responseData;
		module_statuses = module_statuses.map(item => {
			if (getDayJsDiffMinutes(item.updated, now) > OLD_STATUS_MINUTES) {
				item.messages.push({
					id: 'f' + now.unix(),
					level: 'WARNING',
					message: TranslationUtils.t('moduleStatuses.messages.oldStatusUpdate') + ' ' + datetimeToString(item.updated),
					tag: '',
					created: now,
				});
				if (item.status !== 'failed') {
					item.status = 'warnings';
				}
				if (newSummary !== 'failed') {
					newSummary = 'warnings';
				}
			}
			return item;
		});
		update(module_statuses, newSummary);
	};

	const handleError = (): void => {
		update([], 'unknown');
	};

	const refresh = (): void => {
		if (useUserStore().allowToSeeModuleStatuses) {
			ApiModuleStatuses.moduleStatusesGet(handle, handleError);
		}
	};

	return {
		statuses,
		summary,
		update,
		refresh,
	};
});
